import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import GraphQLProvider from "./providers/graphql-provider";
import reportWebVitals from "./reportWebVitals";
import router from "./router";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GraphQLProvider>
      <RouterProvider router={router} />
    </GraphQLProvider>
  </React.StrictMode>
);

reportWebVitals();
